"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ClearButtonComponent = (function () {
    function ClearButtonComponent() {
        var _this = this;
        this.clear = new core_1.EventEmitter();
        this.emitClear = function () {
            _this.clear.emit(_this.clearValue);
        };
    }
    ClearButtonComponent.prototype.ngOnInit = function () {
    };
    return ClearButtonComponent;
}());
ClearButtonComponent.decorators = [
    { type: core_1.Component, args: [{
                // moduleId: module.id,
                selector: "clear-button",
                template: "\n    <font-awesome [faIcon]=\"'remove'\" (click)=\"emitClear()\"></font-awesome>\n  ",
                styles: ["\n    :host font-awesome { cursor: pointer; }\n  "]
            },] },
];
/** @nocollapse */
ClearButtonComponent.ctorParameters = function () { return []; };
ClearButtonComponent.propDecorators = {
    'clearValue': [{ type: core_1.Input },],
    'clear': [{ type: core_1.Output },],
};
exports.ClearButtonComponent = ClearButtonComponent;
//# sourceMappingURL=clear-button.component.js.map